import styled from 'foundations-theming/utils';
import UIDialog from 'UIComponents/dialog/UIDialog';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H1 from 'UIComponents/elements/headings/H1';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StickyContainer = styled.div.withConfig({
  displayName: "BasePrompt__StickyContainer",
  componentId: "sc-1c5z1me-0"
})(["position:fixed;bottom:90px;right:16px;z-index:100;width:450px;box-shadow:2px 2px 7px ", ";"], ({
  theme
}) => theme.color['do-not-use-flint']);
const BasePrompt = ({
  headerText,
  bodyText,
  cta,
  handleClose,
  dataTestId
}) => {
  return /*#__PURE__*/_jsx(StickyContainer, {
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsxs(UIDialog, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleClose,
        "data-test-id": `${dataTestId}-close`
      }), /*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H1, {
          children: headerText
        })
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: bodyText
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: cta
      })]
    })
  });
};
export default BasePrompt;